/**
 * Strips from string all new lines, tabs and carriage returns
 * and replaces them with a space and trims the string
 */
export function stripFormatting(str: string, replaceWith = ' ') {
  return str.replace(/(?:\r\n|\r|\n|\t)/g, replaceWith).trim();
}

/**
 * Strips from string all new lines, tabs and carriage returns
 * as regular characters (instead of control characters)
 * and replaces them with a space and trims the string
 */
export function stripPseudoFormatting(str: string, replaceWith = ' ') {
  return str.replace(/(?:\\r\\n|\\r|\\n)/g, replaceWith).trim();
}

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Include as many whole `parts` as fit within `maxLength` when joined by `separator`.
 * Returns the included parts (first may be end-truncated if it alone exceeds the limit)
 * and how many were omitted.
 */
export function joinUntilMaxLength(
  parts: string[],
  maxLength: number,
  separator = ', ',
): { parts: string[]; text: string; remaining: number } {
  if (parts.length === 0) {
    return { parts: [], text: '', remaining: 0 };
  }

  const included: string[] = [];

  for (const part of parts) {
    const candidate =
      included.length === 0 ? part : `${included.join(separator)}${separator}${part}`;
    if (candidate.length > maxLength) {
      break;
    }
    included.push(part);
  }

  if (included.length === 0) {
    const ellipsis = '...';
    const first = parts[0] ?? '';
    included.push(
      first.length <= maxLength
        ? first
        : `${first.slice(0, Math.max(0, maxLength - ellipsis.length))}${ellipsis}`,
    );
  }

  return {
    parts: included,
    text: included.join(separator),
    remaining: parts.length - included.length,
  };
}
